interface WeekGridHourProps {
  hour: number;
  gridStep: {
    hour: number;
    minute: number;
  };
}

export function WeekGridHour({ gridStep }: WeekGridHourProps) {
  // Formater l'heure en utilisant Intl.DateTimeFormat pour le français
  const formatter = new Intl.DateTimeFormat("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const formattedTime = formatter.format(new Date(0, 0, 0, gridStep.hour, gridStep.minute));

  // Afficher l'heure pour tous les créneaux (pas seulement après le premier)
  return (
    <div className="relative border-t border-gray-200 text-xs">
      <span className="absolute -top-2.5 -left-11 text-gray-500">{formattedTime}</span>
    </div>
  );
}
